import React, { useEffect, useState, } from 'react';
import { Link, useParams, } from 'react-router-dom';
import $ from 'jquery';

import {
    responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, statusListGet, dataTableLanguaje,
    buttonProcessGet, awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import axios from 'axios';

import moment from 'moment-timezone'
import 'react-tempusdominus-bootstrap';
import HtmlParser from 'react-html-parser';

import { condominiumBoardElectionDetailModelGet, } from '../../models/condominiumBoard/electionDetails.js';
import ElectionApplicantsAddEditDetails from './ElectionApplicantsAddEditDetails';
import useAuth from '../../controllers/users/useAuth';
import { apartMentUserRolesApplicantsGetAsync, } from '../../controllers/condominiumBoard/elections';
import Menu from '../main/Menu';
import Swal from 'sweetalert2';
import { condominiumBoardElectionResultsGetAsync } from './helper';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats.js';
import { buildingModelGet } from '../../models/buildings/building.js';
import { condominiumBoardElectionModelGet } from '../../models/condominiumBoard/elections.js';

const currentMethod = 'ElectionEdit';

const { colors, icons, labels, messages, react, } = globalSettings;
const { html: reactHtml, } = react;

export default function ElectionEdit({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    //const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const { id, } = useParams();
    const [processValues, setProcessValues] = useState({ type: null, rowIndex: null, users: [], condominiumBoardRoles: [] });

    let swalProperties = {};

    const [descriptionError, setDescriptionError] = useState('');
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    const [remarkError, setRemarkError] = useState('');
    const [statusError, setStatusError] = useState('');

    const startDateId = 'startDate';
    //const inputStartDateId = 'inputStartDate';
    const endDateId = 'endDate';
    //const inputEndDateId = 'inputEndDate';

    //const selectStatusId = 'selectStatus';
    const statusList = statusListGet({ type: 'S', languageId: languageObj?.id, })?.result;
    const htmlObj = {
        class: 'class',
        formSelect: {
            base: 'form-select',
            bgPrimary: 'form-select bg-primary',
            bgSuccess: 'form-select bg-success',
            bgWarning: 'form-select bg-warning',
            bgInfo: 'form-select bg-info',
            bgSecondary: 'form-select bg-secondary',
        },
    };
    //const [statusClassName, setStatusClassName] = useState(htmlObj?.formSelect?.base);
    const [btnAddDisabled, setBtnAddDisabled] = useState(true);
    const [showLoading, setShowLoading] = useState({ building: true, election: true, applicants: true, });
    //const [showData, setShowData] = useState(false);
    //#endregion variables

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region condominium board election
    let condominiumBoardElectionTwo = condominiumBoardElectionModelGet({});
    const [condominiumBoardElectionClosed, setCondominiumBoardElectionClosed] = useState(false);
    const [condominiumBoardElection, setCondominiumBoardElection] = useState(condominiumBoardElectionModelGet({}));
    //#endregion condominium board election

    //#region condominium board election (details)
    const dtElectionApplicantsId = 'dtElectionApplicants';
    const [electionApplicant, setElectionApplicant] = useState();
    const [electionApplicants, setElectionApplicants] = useState([]);
    const [electionApplicantDelete, setElectionApplicantDelete] = useState({ id: '', description: '', rowIndex: 0, });
    const [electionApplicantShowModal, setElectionApplicantShowModal] = useState(false);
    //#endregion condominium board election (details)

    //#region others
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-warning float-right mx-1',
                id: 'btnSave',
            },
            results: {
                className: 'btn btn-outline-secondary float-right',
                id: 'btnResults',
            },
            back: {
                className: 'btn btn-outline-success float-right mx-1',
                id: 'btnBack',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            applicants: {
                inputs: {
                    search: {
                        id: `${dtElectionApplicantsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtElectionApplicantsId}_length select`,
                        className: '',
                    },
                },
                buttons: {
                    create: {
                        id: `btnApplicantsCreate`,
                        className: 'btn btn-outline-success float-right btn-sm',
                    },
                    delete: {
                        className: 'btn btn-outline-danger float-right btn-sm mx-1',
                        id: 'btnApplicantsDelete',
                    },
                },
                icons: {
                    create: {
                        id: 'icoApplicantsCreate',
                        className: icons?.plusCircle,
                    },
                    delete: {
                        id: 'icoApplicantsDelete',
                        className: icons?.plusCircle,
                    },
                },
                spinners: {
                    create: {
                        id: 'spApplicantsCreate',
                        className: '',
                    },
                    delete: {
                        id: 'spApplicantsDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            save: {
                id: 'iconSave',
                className: icons?.save,
            },
            back: {
                id: 'iconBack',
                className: icons?.arrowCircleLeft,
            },
            results: {
                id: 'iconResults',
                className: icons?.chartBar,
            },
        },
        inputs: {
            description: {
                id: 'inputDescription',
                className: 'form-control',
            },
            remark: {
                id: 'inputRemark',
                //className: 'form-control bg-transparent text-black',
                className: 'form-control',
            },
            endDate: {
                id: 'inputEndDate',
                //className: 'form-control text-black bg-transparent datetimepicker-input',
                className: 'form-control datetimepicker-input',
            },
            startDate: {
                id: 'inputStartDate',
                //className: 'form-control text-black bg-transparent datetimepicker-input',
                className: 'form-control datetimepicker-input',
            },
        },
        selects: {
            status: {
                id: 'inputStatus',
                className: 'form-select',
            },
        },
        radios: {
            // even: {
            //     id: 'radioEven',
            //     className: 'icheck-primary d-inline mx-4',
            // },
            // odd: {
            //     id: 'radioOdd',
            //     className: 'icheck-primary d-inline',
            // },
            // both: {
            //     id: 'radioBoth',
            //     className: 'icheck-primary d-inline mx-4',
            // },
        },
        spinners: {
            save: {
                id: 'spSave',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
            results: {
                id: 'spResults',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region condominium board election (methods)
    const condominiumBoardElectionEditAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardElectionEditAsync';
        let response = responseGet();
        try {
            //#region variables
            let condominiumBoardElectionClosedLocal = false;
            let condominiumBoardElectionLocal = condominiumBoardElectionModelGet({});
            //#endregion variables

            //#region initialize
            e?.preventDefault();
            response = await errorDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region data set
            response = await dataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion data set

            //#region formDataValidateAsync
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion formDataValidateAsync

            //#region check if now close election
            if (!isUndNullEmp({ data: condominiumBoardElection?.status, subMethod: currentMethod, })?.result && condominiumBoardElection?.status === 3) {
                let msgText = `${messages?.onceClosedYouWillNotBeAbleToOpenOrEditIt?.[languageObj?.id]}<br/>`;
                msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

                swalProperties = {
                    icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                    title: messages?.areYouSureYouWantToCloseThisDocument?.[languageObj?.id],
                    html: msgText,
                    timer: null,
                    confirmButtonColor: colors?.warningColorExp,
                    confirmButtonText: labels?.yes?.[languageObj?.id],
                    showCancelButton: true,
                    cancelButtonColor: colors?.successColorExp,
                    cancelButtonText: labels?.no?.[languageObj?.id],
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                };

                const { isConfirmed, } = await Swal.fire(swalProperties);
                if (!isConfirmed) {
                    return;
                }
            }
            //#endregion check if now close election

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region update condominum board election
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                condominiumBoardElection: condominiumBoardElection,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElections}/${condominiumBoardElection.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            condominiumBoardElectionTwo = response.result;
            condominiumBoardElectionLocal = condominiumBoardElectionTwo;
            setCondominiumBoardElection(condominiumBoardElectionLocal);
            condominiumBoardElectionClosedLocal = !isUndNullEmp({ data: condominiumBoardElectionLocal?.status, subMethod: currentMethod, })?.result &&
                condominiumBoardElectionLocal?.status === 3 ?
                true :
                false;
            setCondominiumBoardElectionClosed(condominiumBoardElectionClosedLocal);

            //#region data table (load data)
            if (condominiumBoardElectionClosedLocal) {
                //#region old code
                // response = localDataTablesClear(true);
                // if (!response?.isSuccess || response?.isWarning) {
                //     await sendMessageCloseCurrentWindowAsync({
                //         msgType: response?.msgType,
                //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                //         closeWindow: false,
                //         urlGoTo: response?.urlGoTo,
                //         auth: auth,
                //         isLogout: false,
                //         languageId: languageObj?.id,
                //         subMethod: currentMethod,
                //     });
                //     return;
                // }
                //#endregion old code
                $(`#${dtElectionApplicantsId}`)?.DataTable()?.rows()?.clear()?.draw(true);

                setShowLoading({ building: false, election: false, applicants: true, });

                response = dataTableDataLoad({
                    details: electionApplicants,
                    condominiumBoardElectionClosed: condominiumBoardElectionClosedLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    setShowLoading({ building: false, election: false, applicants: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                setShowLoading({ building: false, election: false, applicants: false, });
            }
            //#endregion data table (load data)
            //#endregion update condominum board election

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, election: false, applicants: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                start: $(`#${startDateId}`)?.datetimepicker('date')?._d,
                end: $(`#${endDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            condominiumBoardElection.status = parseInt($(`#${controls?.selects?.status?.id}`)?.prop('value'));

            condominiumBoardElection.endDate = !isUndNullEmp({ data: dateTimeObj?.end, subMethod: currentMethod, })?.result ? dateTimeObj?.end : condominiumBoardElection?.endDate;
            condominiumBoardElection.startDate = !isUndNullEmp({ data: dateTimeObj?.start, subMethod: currentMethod, })?.result ? dateTimeObj?.start : condominiumBoardElection?.startDate;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const condominiumBoardElectionResultsLocalGetAsync = async ({ e = {}, id = '', subMethod = '', }) => {
        const currentMethod = 'condominiumBoardElectionResultsLocalGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });

            //#region methods
            response = await condominiumBoardElectionResultsGetAsync({
                id: id,
                buildingId: building?.id,
                isResumen: false,
                auth: auth,
                reportName: globalSettings?.app?.reports?.electionResultsPrint,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion methods

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion condominium board election (methods)

    //#region condominium board election (details - methods)
    const dataTableElectionApplicantsSet = ({ subMethod = '', }) => {
        const currentMethod = '';
        let response = responseGet();
        try {
            $(`#${dtElectionApplicantsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    {
                        title: labels?.name?.[languageObj?.id],
                        orderable: false,
                        render: function (data, type, row) {
                            let dataLocal = '';
                            dataLocal = `<span>${globalSettings?.html?.space?.formatOne} ${data}</span>`;
                            return dataLocal;
                        },
                        width: '60%',
                    },
                    { title: labels?.floor?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.apartment?.[languageObj?.id], width: '10%', orderable: false, },
                    { title: labels?.role?.[languageObj?.id], width: '10%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.hierarchy?.[languageObj?.id], width: '5%', orderable: false, searchable: false, visible: false, },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                drawCallback: function (settings) {
                    try {
                        var api = this.api();
                        var rows = api.rows({ page: 'current' }).nodes();
                        var last = null;

                        api
                            .column(3, { page: 'current' })
                            .data()
                            .each(function (groupName, index) {
                                if (last !== groupName) {
                                    $(rows)
                                        .eq(index)
                                        // .before('<tr class="group"><td colspan="5">' + group + '</td></tr>');
                                        //.before('<tr bgcolor="#ddd"><td colspan="5">' + group + '</td></tr>');
                                        .before(`<tr bgcolor="#ddd" style="font-weight:bold"><td colspan="4 ">${groupName}</td></tr>`);
                                    last = groupName;
                                }
                            });
                    } catch (ex) {
                        response.msgType = -1;
                        response.isSuccess = false;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            response.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        response.msgText += `Error: ${ex?.message}`;
                        console?.error(response);
                    }
                },
                //dom: '<"toolbar">frtip',
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[4, 'asc'], [0, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtElectionApplicantsId}_wrapper .col-md-6:eq(0)`);
            });
            //$('div.toolbar').html('<b>Nikole</b>');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const electionApplicantAddEditDetailsDeleteAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'electionApplicantAddEditDetailsDeleteAsync';
        let response = responseGet();
        try {
            //#region initialize
            e?.preventDefault();
            //#endregion initialize

            //#region variables
            let showModal = false;
            const buildingIdLocal = condominiumBoardElection?.buildingId || condominiumBoardElectionTwo?.buildingId;
            //#endregion variables

            if (processType === 0) {
                controlsStatusSet({ processType: 4, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, election: false, applicants: true, });
            }

            //#region process
            //#region get users and roles
            response = await apartMentUserRolesApplicantsGetAsync({
                buildingId: buildingIdLocal,
                withDetails: true,
                auth: auth,
                languageId: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            setProcessValues({
                ...processValues,
                type: processType,
                rowIndex: rowIndex,
                users: response?.result?.apartmentUsers,
                condominiumBoardRoles: response?.result?.condominiumBoardRoles,
            });
            //#endregion get users and roles

            //#region old code
            // switch (processType) {
            //     //#region old code
            //     // case -1:
            //     //     setElectionApplicantDelete({ id, description, rowIndex });
            //     //     $(`#${btnCondominiumBoardElectionDetailDeleteId}`)?.trigger('click');
            //     //     return;
            //     //#endregion old code
            //     case 0:
            //         setElectionApplicant(
            //             condominiumBoardElectionDetailModelGet({
            //                 condominiumBoardElectionId: condominiumBoardElection?.id,
            //                 buildingId: condominiumBoardElection?.buildingId,
            //                 userId: auth?.user?.uid,
            //                 userElectionId: '',
            //                 condominiumBoardRoleId: '',
            //             })
            //         );
            //         break;
            //     case 1 || 2:
            //         //#region old code
            //         //response = await localCondominiumBoardElectionDetailsGetAsync(id);
            //         //#endregion old code

            //         headerObj = {
            //             headers: {
            //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //                 languageId: languageObj?.id,
            //             },
            //             url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElectionDetails}/${id}`,
            //         };

            //         result = await axios?.get(
            //             headerObj?.url,
            //             headerObj,
            //         );

            //         response = result?.data;

            //         if (!response?.isSuccess || response?.isWarning) {
            //             setShowLoading({ building: false, election: false, applicants: false, });
            //             await sendMessageCloseCurrentWindowAsync({
            //                 msgType: response?.msgType,
            //                 msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //                 closeWindow: false,
            //                 urlGoTo: response?.urlGoTo,
            //                 auth: auth,
            //                 isLogout: false,
            //                 languageId: languageObj?.id,
            //                 subMethod: currentMethod,
            //             });
            //             return;
            //         }

            //         setElectionApplicant(response.result);
            //         break;
            //     //#region old code
            //     // case 2:
            //     //     response = await localCondominiumBoardElectionDetailsGetAsync(id);
            //     //     if (!response?.isSuccess || response?.isWarning) {
            //     //         await sendMessageCloseCurrentWindowAsync({
            //     //             msgType: response?.msgType,
            //     //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //     //             closeWindow: false,
            //     //             urlGoTo: response?.urlGoTo,
            //     //             auth: auth,
            //     //             isLogout: false,
            //     //             languageId: languageObj?.id,
            //     //             subMethod: currentMethod,
            //     //         });
            //     //         return;
            //     //     }
            //     //     break;
            //     //#endregion old code
            //     default:
            //         processType = 3;
            //         break;
            // }
            //#endregion old code

            if (processType === 0) {
                setElectionApplicant(
                    condominiumBoardElectionDetailModelGet({
                        condominiumBoardElectionId: condominiumBoardElection?.id,
                        buildingId: condominiumBoardElection?.buildingId,
                        userId: auth?.user?.uid,
                        userElectionId: '',
                        condominiumBoardRoleId: '',
                    })
                );

                showModal = true;
            } else if (processType === 1 || processType === 2) {
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        languageId: languageObj?.id,
                    },
                    url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElectionDetails}/${id}`,
                };

                result = await axios?.get(
                    headerObj?.url,
                    headerObj,
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, election: false, applicants: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                setElectionApplicant(response.result);
                showModal = true;
            } else {
            }
            //#endregion process

            if (processType === 0) {
                await awaitDelay({ delayTimer: globalSettings?.timers?.threeNanoSeconds, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType === -1) {
                //#region applicant set data
                setElectionApplicantDelete({ id: id, description: description, rowIndex: rowIndex, });
                //#endregion applicant set data

                setShowLoading({ building: false, election: false, applicants: false, });

                $(`#${controls?.dataTables?.applicants?.buttons?.delete?.id}`)?.trigger('click');
            } else {
                setShowLoading({ building: false, election: false, applicants: false, });
            }

            setElectionApplicantShowModal(showModal);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, election: false, applicants: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old code
    // const localCondominiumBoardElectionDetailsGetAsync = async (id = '') => {
    //     let response = responseGet();
    //     try {
    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };

    //         //result = await axios?.get(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElectionDetails}/${id}`, headerObj);
    //         result = await axios?.get(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElectionDetails}/${id}`, headerObj);
    //         response = result.data;
    //         if (!response?.isSuccess || response?.isWarning) {
    //             return response;
    //         }
    //         setElectionApplicant(response.result);
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCondominiumBoardElectionDetailsGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    //#region old code
    // const condominiumBoardElectionDetailDeleteGetAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         //#region initialize

    //         e?.preventDefault();

    //         //#endregion initialize

    //         //#region get applicant data

    //         const localApplicantData = electionApplicants.filter(({ id, }) => id === electionApplicantDelete.id);

    //         if (isUndefined(localApplicantData) || isNull(localApplicantData) || localApplicantData.length <= 0) {
    //             response.isWarning = true;
    //             response.msgType = 1;
    //             response.msgText = `${messages?.theRecordCannotBeLocated?.[languageObj?.id]}<br/>`;
    //             response.msgText += `${labels?.applicant?.[languageObj?.id]}: ${electionApplicantDelete.description}<br/>`;
    //             response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return response;
    //         }

    //         response = await userDataGetAsync(localApplicantData[0].userElectionId, localApplicantData[0].condominiumBoardRoleId, null, currentMethod,);
    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return response;
    //         }

    //         //#endregion get applicant data

    //         //#region show message

    //         let msgText = `${labels?.applicant?.[languageObj?.id]}: <b>${response?.result?.fullName}</b><br/>`;
    //         msgText += `${labels?.role?.[languageObj?.id]}: <b>${response?.result?.role.description}</b><br/>`;
    //         msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         const localSwalProperties = {
    //             icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: msgText,
    //             timer: null,
    //             confirmButtonColor: colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(localSwalProperties);

    //         //#endregion show message

    //         //#region delete data

    //         if (isConfirmed) {
    //             sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //             headerObj = {
    //                 headers: {
    //                     authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //                 },
    //             };

    //             //result = await axios.delete(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElectionDetails}/${electionApplicantDelete.id}`, headerObj);
    //             result = await axios.delete(c, headerObj);
    //             response = result.data;
    //             if (!response?.isSuccess || response?.isWarning) {
    //                 await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //                 return response;
    //             }

    //             const localElectionApplicants = electionApplicants.filter(({ id }) => id !== electionApplicantDelete.id);
    //             setElectionApplicants(localElectionApplicants);
    //             $(`#${dtElectionApplicantsId}`)?.DataTable()?.row(electionApplicantDelete.rowIndex)?.remove()?.draw(true);

    //             sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
    //         }

    //         //#endregion delete data
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: condominiumBoardElectionDetailDeleteGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    //     return response;
    // }
    //#endregion old code

    //#region old code
    // const electionApplicantDeleteGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, subMethod = '', }) => {
    //     const currentMethod = 'electionApplicantDeleteGetAsync';
    //     let response = responseGet();
    //     try {
    //         e?.preventDefault();

    //         //#region applicant set data
    //         setElectionApplicantDelete({ id: id, description: description, rowIndex: rowIndex, });
    //         //#endregion applicant set data

    //         $(`#${controls?.dataTables?.applicants?.buttons?.delete?.id}`)?.trigger('click');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync({
    //             msgType: response?.msgType,
    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: auth,
    //             isLogout: false,
    //             languageId: languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //         return;
    //     }
    // }
    //#endregion old code

    const electionApplicantDeletePostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'electionApplicantDeletePostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region get applicant data
            const applicantData = electionApplicants.filter(({ id, }) => id === electionApplicantDelete?.id);

            if (isUndNullEmp({ data: applicantData, subMethod: currentMethod, })?.result || applicantData?.length <= 0) {
                response.msgType = 1;
                response.isWarning = true;
                response.msgText = `${messages?.theRecordCannotBeLocated?.[languageObj?.id]}<br/>`;
                response.msgText += `${labels?.applicant?.[languageObj?.id]}: ${electionApplicantDelete.description}<br/>`;
                response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            response = await userDataGetAsync({
                userElectionid: applicantData?.[0]?.userElectionId,
                condominiumBoardRoleId: applicantData?.[0]?.condominiumBoardRoleId,
                processValuesTwo: null,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion get applicant data

            //#region show message
            let msgTextObj = {
                one: `${labels?.applicant?.[languageObj?.id]}: <b>${electionApplicantDelete?.description}</b><br/>`,
                two: `${labels?.role?.[languageObj?.id]}: <b>${response?.result?.role?.description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });

                        //#region delete condominiumBoardRole
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElectionDetails}/${electionApplicantDelete?.id}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        const electionApplicantsLocal = electionApplicants.filter(({ id }) => id !== electionApplicantDelete?.id);
                        setElectionApplicants(electionApplicantsLocal);
                        //#endregion delete condominiumBoardRole

                        //#region delete condominiumBoardRole (dataTable)
                        $(`#${dtElectionApplicantsId}`)?.DataTable()?.row(electionApplicantDelete.rowIndex)?.remove()?.draw(true);
                        //#endregion delete condominiumBoardRole (dataTable)

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const dataTableDataLoad = ({ details = [], condominiumBoardElectionClosed = false, subMethod = '', }) => {
        const currentMethod = 'dataTableDataLoad';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            //#endregion variables

            //#region data load
            details?.forEach((detail) => {
                dtRows.push([
                    `${detail?.apartmentUser?.user?.firstName} ${detail?.apartmentUser?.user?.lastName}`,
                    detail?.apartmentUser?.apartment?.floor,
                    detail?.apartmentUser?.apartment?.identifier,
                    detail?.condominiumBoardRole?.description,
                    detail?.condominiumBoardRole?.hierarchy,
                    buttonProcessGet({
                        id: detail?.id,
                        description: `${detail?.apartmentUser?.user?.firstName} ${detail?.apartmentUser?.user?.lastName}`,
                        showDetails: true,
                        labelDetails: labels?.detail?.[languageObj?.id],
                        enabledDetails: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: !condominiumBoardElectionClosed,
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: !condominiumBoardElectionClosed,
                        processButtons: [],
                        subMethod: currentMethod,
                    }).result,
                ]);
            });

            $(`#${dtElectionApplicantsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion data load
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion condominium board election (details - methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, election: true, applicants: true, });

            //#region variables initialize
            let detailsLocal = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let condominiumBoardElectionClosedLocal = false;
            let buildingLocal = buildingModelGet({});
            let condominiumBoardElectionLocal = condominiumBoardElectionModelGet({});

            setBuilding({});
            setCondominiumBoardElection({});
            //#endregion variables initialize

            //#region set datatables
            response = dataTablesSet({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, election: false, applicants: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion set datatables

            //#region get condominium board election (with details)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                conditionals: [],
                ordersBy: [],
                id: id,
                withDetails: true,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCondominiumBoardElections}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, election: false, applicants: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            condominiumBoardElectionTwo = response?.result?.condominiumBoardElection;
            condominiumBoardElectionLocal = condominiumBoardElectionTwo;
            setCondominiumBoardElection(condominiumBoardElectionLocal);
            condominiumBoardElectionClosedLocal =
                !isUndNullEmp({ data: condominiumBoardElectionLocal?.status, subMethod: currentMethod, })?.result && condominiumBoardElectionLocal?.status === 3 ?
                    true :
                    false;
            setCondominiumBoardElectionClosed(condominiumBoardElectionClosedLocal);
            buildingLocal = response?.result?.building;
            setBuilding(buildingLocal);
            detailsLocal = response?.result?.details;
            setElectionApplicants(detailsLocal);
            //#endregion get condominium board election (with details)

            //#region set is edit, details, delete
            if (!isUndNullEmp({ data: detailsLocal, subMethod: currentMethod, })?.result && detailsLocal?.length > 0) {
                isEditLocal = processEvaluateGet({
                    object: detailsLocal?.[0],
                    property: labels?.process?.en?.toLowerCase(),
                    process: labels?.edit?.en?.toLowerCase(),
                    subMethod: currentMethod,
                })?.result;
                isDeleteLocal = processEvaluateGet({
                    object: detailsLocal?.[0],
                    property: labels?.process?.en?.toLowerCase(),
                    process: labels?.delete?.en?.toLowerCase(),
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                isEditLocal = processEvaluateGet({
                    object: buildingLocal,
                    property: labels?.process?.en?.toLowerCase(),
                    process: labels?.edit?.en?.toLowerCase(),
                    subMethod: currentMethod,
                })?.result;
                isDeleteLocal = isEditLocal;
            }

            setBtnAddDisabled(!(isEditLocal && isDeleteLocal));
            //#endregion set is edit, details, delete

            //#region Status background color
            response = await statusColorSetAsync({
                statusId: condominiumBoardElectionLocal?.status?.toString(),
                e: {},
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, election: false, applicants: false, });
                return;
            }

            //setStatusClassName(response?.result);
            //$(`#${controls?.selects?.status?.id}`)?.attr(htmlObj?.class, response?.result);
            //#endregion Status background color

            setShowLoading(false);
            //setShowData(true);

            //#region set datatables / set data on datatables
            response = dataTableDataLoad({
                details: detailsLocal,
                condominiumBoardElectionClosed: condominiumBoardElectionClosedLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, election: false, applicants: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion set datatables / set data on datatables

            //#region set date time
            response = dateInControlSet({
                date: new Date(),
                startDate: condominiumBoardElectionLocal?.startDate,
                endDate: condominiumBoardElectionLocal?.endDate,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, election: false, applicants: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion set date time

            setShowLoading({ building: false, election: false, applicants: false, });
        } catch (ex) {
            setShowLoading({ building: false, election: false, applicants: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const statusColorSetAsync = async ({ statusId = '', e = null, subMethod = '', }) => {
        const currentMethod = 'statusColorSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const selectObjLocal = $(`#${controls?.selects?.status?.id}`);
            //#endregion variables

            if (condominiumBoardElectionClosed) {
                selectObjLocal?.prop({ value: `${condominiumBoardElection?.status}`, });
                return;
            }

            //#region methods
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                setCondominiumBoardElection({ ...condominiumBoardElection, status: parseInt(e?.target?.value), });
            } else {
                selectObjLocal?.prop({ value: statusId, });
            }

            switch (statusId) {
                case '':
                    selectObjLocal?.attr(htmlObj?.class, htmlObj?.formSelect?.base);
                    response.result = htmlObj?.formSelect?.base;
                    break;
                case '0':
                    selectObjLocal?.attr(htmlObj?.class, htmlObj?.formSelect?.bgPrimary);
                    response.result = htmlObj?.formSelect?.bgPrimary;
                    break;
                case '1':
                    selectObjLocal?.attr(htmlObj?.class, htmlObj?.formSelect?.bgSuccess);
                    response.result = htmlObj?.formSelect?.bgSuccess;
                    break;
                case '2':
                    selectObjLocal?.attr(htmlObj?.class, htmlObj?.formSelect?.bgWarning);
                    response.result = htmlObj?.formSelect?.bgWarning;
                    break;
                case '3':
                    selectObjLocal?.attr(htmlObj?.class, htmlObj?.formSelect?.bgInfo);
                    response.result = htmlObj?.formSelect?.bgInfo;
                    //localSelectObj.attr(htmlObj?.class, htmlObj?.formSelect?.bgSecondary);
                    //response.result = htmlObj?.formSelect?.bgSecondary;
                    break;
                default:
                    selectObjLocal?.attr(htmlObj?.class, htmlObj?.formSelect?.base);
                    response.result = htmlObj?.formSelect?.base;
                    break;
            }
            //#endregion methods
        } catch (ex) {
            response.result = 'form-select bg-danger';
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            response = dataTableElectionApplicantsSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = queryCodeSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region condominium board election detail
            $(`#${dtElectionApplicantsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtElectionApplicantsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            electionApplicantAddEditDetailsDeleteAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            electionApplicantAddEditDetailsDeleteAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            electionApplicantAddEditDetailsDeleteAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion condominium board election detail
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const goToBackAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });
            setShowLoading({ building: true, election: true, applicants: true, });

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

            window.location.href = globalSettings?.app?.backend?.urlCondominiumBoardElections;
            setShowLoading({ building: false, election: false, applicants: false, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setShowLoading({ building: false, election: false, applicants: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const errorDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorDefaultSetAsync';
        let response = responseGet();
        try {
            setStatusError('');
            setRemarkError('');
            setEndDateError('');
            setStartDateError('');
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                start: $(`#${controls?.inputs?.startDate?.id}`)?.val(),
                end: $(`#${controls?.inputs?.endDate?.id}`)?.val(),
                startDtp: $(`#${startDateId}`)?.datetimepicker('date')?._d,
                endDtp: $(`#${endDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: condominiumBoardElection?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: condominiumBoardElection?.remark, subMethod: currentMethod, })?.result) {
                setDescriptionError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.startDtp, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: condominiumBoardElection?.startDate, subMethod: currentMethod, })?.result) {
                setStartDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.endDtp, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: condominiumBoardElection?.endDate, subMethod: currentMethod, })?.result) {
                setEndDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (moment(new Date(dateTimeObj?.endDtp).toUTCString()).isBefore(new Date(dateTimeObj?.startDtp).toUTCString())) {
                setStartDateError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                setEndDateError(messages?.dateToMustBeGreaterThanDateFrom?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: condominiumBoardElection?.status, subMethod: currentMethod, })?.result || condominiumBoardElection?.status === -1) {
                setStatusError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            } else if ((condominiumBoardElection?.status === 1 || condominiumBoardElection?.status === 2 || condominiumBoardElection?.status === 3) &&
                electionApplicants?.length <= 0) {
                response.isWarning = true;
                response.msgType = 1;
                response.msgText = `${messages?.youCannotModifyTheStatusWithoutAddingDetails?.[languageObj?.id]}<br/>`;
                response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateInControlSet = ({ date = new Date(), startDate = '', endDate = '', subMethod = '', }) => {
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.start = '';
            //let dateTimeObj?.end = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //#endregion old code
            const dateTimeObj = {
                start: '',
                end: '',
                format: languageObj?.format?.date?.f1,
                //formatTwo: `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: globalSettings?.react?.tempusDominus?.icons,
                buttons: globalSettings?.react?.tempusDominus?.buttons,
                tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            if (!isUndNullEmp({ data: startDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.start = dateTimeFormatGlobalSet({
                    date: startDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.start = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (!isUndNullEmp({ data: endDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.end = dateTimeFormatGlobalSet({
                    date: endDate,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.end = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $(`#${startDateId}`)?.datetimepicker({
                date: moment(`${dateTimeObj?.start}`, dateTimeObj?.formatTwo),
                default: false,
                format: dateTimeObj?.formatTwo,
            });

            $(`#${endDateId}`)?.datetimepicker({
                //date: moment(`${dateTimeObj?.end}`, localDateFormatTwo).endOf('month'),
                date: moment(`${dateTimeObj?.end}`, dateTimeObj?.formatTwo),
                default: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const keyDownAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'keyDownAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.key, subMethod: currentMethod, })?.result && e?.key === 'Enter') {
                switch (e?.target?.id) {
                    case controls?.inputs?.startDate?.id:
                        condominiumBoardElectionEditAsync({ e: e, subMethod: currentMethod, });
                        break;
                    case controls?.inputs?.endDate?.id:
                        condominiumBoardElectionEditAsync({ e: e, subMethod: currentMethod, });
                        break;
                    default:
                        break;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const userDataGetAsync = async ({ userElectionid = '', condominiumBoardRoleId = '', processValuesTwo = {}, subMethod = '', }) => {
        const currentMethod = 'userDataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let user;
            let condominiumBoardRole;
            response.result = {
                fullName: '',
                floor: 0,
                identifier: '',
                condominiumBoardElection: {},
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: processValuesTwo, subMethod: currentMethod, })?.result) {
                user = !isUndNullEmp({ data: processValuesTwo?.users, subMethod: currentMethod, })?.result ?
                    processValuesTwo?.users?.filter(({ userId }) => userId === userElectionid) : null;
                condominiumBoardRole = !isUndNullEmp({ data: processValuesTwo?.condominiumBoardRoles, subMethod: currentMethod, })?.result ?
                    processValuesTwo?.condominiumBoardRoles?.filter(({ id }) => id === condominiumBoardRoleId) : null;
            } else {
                user = !isUndNullEmp({ data: processValues?.users, subMethod: currentMethod, })?.result ?
                    processValues?.users?.filter(({ userId }) => userId === userElectionid) : null;
                condominiumBoardRole = !isUndNullEmp({ data: processValues?.condominiumBoardRoles, subMethod: currentMethod, })?.result ?
                    processValues?.condominiumBoardRoles?.filter(({ id }) => id === condominiumBoardRoleId) : null;
            }

            if (!isUndNullEmp({ data: user, subMethod: currentMethod, })?.result && user?.length > 0) {
                response.result.fullName = `${user?.[0]?.user?.firstName} ${user?.[0]?.user?.lastName}`;
                response.result.floor = user?.[0]?.apartment?.floor;
                response.result.identifier = user?.[0]?.apartment?.identifier;
                response.result.role = condominiumBoardRole?.[0];
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old code
    // const localDataTablesClear = (dtElectionApplicantsClear = false) => {
    //     let response = responseGet();
    //     try {
    //         if (dtElectionApplicantsClear) {
    //             $(`#${dtElectionApplicantsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localDataTablesClear<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }

                    $(`#${controls?.dataTables?.applicants?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.applicants?.spinners?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.applicants?.icons?.create?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.applicants?.buttons?.create?.id}`)?.addClass(controls?.dataTables?.applicants?.buttons?.create?.className);
                    $(`#${controls?.dataTables?.applicants?.spinners?.create?.id}`)?.addClass(controls?.dataTables?.applicants?.spinners?.create?.className);
                    $(`#${controls?.dataTables?.applicants?.icons?.create?.id}`)?.addClass(controls?.dataTables?.applicants?.icons?.create?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.results?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.results?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.dataTables?.applicants?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.applicants?.spinners?.create?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr('readOnly', (processType !== 0 || condominiumBoardElectionClosed));
            $(`#${controls?.inputs?.remark?.id}`)?.attr('readOnly', (processType !== 0 || condominiumBoardElectionClosed));
            $(`#${controls?.inputs?.startDate?.id}`)?.attr('disabled', (processType !== 0 || condominiumBoardElectionClosed));
            $(`#${controls?.inputs?.endDate?.id}`)?.attr('disabled', (processType !== 0 || condominiumBoardElectionClosed));
            $(`#${controls?.selects?.status?.id}`).attr('disabled', (processType !== 0 || condominiumBoardElectionClosed));
            //#endregion controls

             //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

           //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

             //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            $(`#${controls?.dataTables?.applicants?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.applicants?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.results?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.dataTables?.applicants?.buttons?.create?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu process='condominiumBoardElections' viewName='condominiumBoard' />

            <div className='content-wrapper'>
                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.condominiumBoard?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={globalSettings?.app?.backend?.urlCondominiumBoardElections}>{labels?.elections?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.edit?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>
                                {/*buildings*/}
                                <BuildingHeader buildingsId={''}
                                    building={building}
                                    buildings={[]}
                                    btnSyncDisabled={true}
                                    methodGetAsync={null}
                                    processType={1}
                                    headerSectionValues={{}}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*condominium board elections (details)*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.election}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.election?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.condominiumBoardElections}></img> - {labels?.election?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        {/* {!showLoading ? */}
                                        {/* <div> */}
                                        {/* {showData ? */}
                                        {/* <div> */}
                                        <form onSubmit={(e) => condominiumBoardElectionEditAsync({ e: e, subMethod: 'form - onSubmit', })}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.description?.id}
                                                                className={controls?.inputs?.description?.className}
                                                                disabled={condominiumBoardElectionClosed}
                                                                onChange={(e) => setCondominiumBoardElection({ ...condominiumBoardElection, description: e?.target?.value, })}
                                                                onFocus={() => setDescriptionError('')}
                                                                placeholder={labels?.description?.[languageObj?.id]}
                                                                readOnly={condominiumBoardElectionClosed}
                                                                tooltip='tooltip'
                                                                title={labels?.description?.[languageObj?.id]}
                                                                value={condominiumBoardElection?.description || ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.spellCheck} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-md-3'>
                                                    <div className='form-group'>
                                                        {/* <DatePicker /> */}
                                                        <div className='input-group mb-3'>
                                                            <div id={startDateId} className='input-group date' data-target-input='nearest'>
                                                                <input id={controls?.inputs?.startDate?.id}
                                                                    className={controls?.inputs?.startDate?.className}
                                                                    data-target={`#${startDateId}`}
                                                                    data-toggle='datetimepicker'
                                                                    disabled={condominiumBoardElectionClosed}
                                                                    onFocus={() => {
                                                                        setEndDateError('');
                                                                        setStartDateError('');
                                                                    }}
                                                                    onKeyDown={(e) => keyDownAsync({ e: e, subMethod: 'input - startDate', })}
                                                                    placeholder={labels?.start?.[languageObj?.id]}
                                                                    readOnly={condominiumBoardElectionClosed}
                                                                    tooltip='tooltip'
                                                                    title={labels?.start?.[languageObj?.id]}
                                                                    type='text' />
                                                                <div className='input-group-append' data-target={`#${startDateId}`} data-toggle='datetimepicker'>
                                                                    <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(startDateError)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-md-3'>
                                                    <div className='form-group'>
                                                        {/* <DatePicker /> */}
                                                        <div className='input-group mb-3'>
                                                            <div id={endDateId} className='input-group date' data-target-input='nearest'>
                                                                <input id={controls?.inputs?.endDate?.id}
                                                                    className={controls?.inputs?.endDate?.className}
                                                                    data-target={`#${endDateId}`}
                                                                    data-toggle='datetimepicker'
                                                                    disabled={condominiumBoardElectionClosed}
                                                                    onFocus={() => {
                                                                        setEndDateError('');
                                                                        setStartDateError('');
                                                                    }}
                                                                    onKeyDown={(e) => keyDownAsync({ e: e, subMethod: 'input - endDate', })}
                                                                    placeholder={labels?.end?.[languageObj?.id]}
                                                                    readOnly={condominiumBoardElectionClosed}
                                                                    tooltip='tooltip'
                                                                    title={labels?.end?.[languageObj?.id]}
                                                                    type='text' />
                                                                <div className='input-group-append' data-target={`#${endDateId}`} data-toggle='datetimepicker'>
                                                                    <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(endDateError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <textarea id={controls?.inputs?.remark?.id}
                                                                className={controls?.inputs?.remark?.className}
                                                                disabled={condominiumBoardElectionClosed}
                                                                onChange={(e) => setCondominiumBoardElection({ ...condominiumBoardElection, 'remark': e?.target?.value, })}
                                                                onFocus={() => setRemarkError('')}
                                                                placeholder={labels?.remark?.[languageObj?.id]}
                                                                readOnly={condominiumBoardElectionClosed}
                                                                rows={3}
                                                                tooltip='tooltip'
                                                                title={labels?.remark?.[languageObj?.id]}
                                                                value={condominiumBoardElection?.remark || ''}>
                                                            </textarea>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.edit} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(remarkError)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-md-3'></div>

                                                <div className='col-md-3'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <select id={controls?.selects?.status?.id}
                                                                className={controls?.selects?.status?.className}
                                                                //id={controls?.selects?.status?.id}
                                                                //className={statusClassName}
                                                                defaultValue={condominiumBoardElection?.status?.toString() || '-1'}
                                                                disabled={condominiumBoardElectionClosed}
                                                                onClick={(e) => condominiumBoardElectionClosed ? e.defaultPrevented() : e}
                                                                onChange={(e) => statusColorSetAsync({ statusId: e?.target?.value, e: e, subMethod: 'sel - status', })}
                                                                onFocus={() => setStatusError('')} >
                                                                <option value='-1'>{messages?.selectStatus?.[languageObj?.id]}</option>
                                                                {statusList?.map((detail) => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                                            </select>
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={icons?.toggleOn} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(statusError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.className}
                                                        //disabled={isEmpty(building) || condominiumBoardElectionClosed}
                                                        onClick={(e) => goToBackAsync({ e: e, subMethod: 'btn - back', })}
                                                        tooltip='tooltip'
                                                        title={labels?.back?.[languageObj?.id]}
                                                        type='button'>
                                                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.results?.id}
                                                        className={controls?.buttons?.results?.className}
                                                        //disabled={isEmpty(building) || !condominiumBoardElectionClosed}
                                                        disabled={isUndNullEmp({ data: building, subMethod: 'btn - resultsGet', })?.result || !condominiumBoardElectionClosed}
                                                        //disabled={isUndNullEmp({ data: building, subMethod: 'btn - resultsGet', })?.result}
                                                        onClick={(e) => condominiumBoardElectionResultsLocalGetAsync({ e: e, id: condominiumBoardElection?.id, subMethod: 'btn - resultsGet', })}
                                                        tooltip='tooltip'
                                                        title={labels?.results?.[languageObj?.id]}
                                                        type='button'>
                                                        <i id={controls?.icons?.results?.id} className={controls?.icons?.results?.className} /> <span id={controls?.spinners?.results?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.save?.id}
                                                        className={controls?.buttons?.save?.className}
                                                        disabled={isUndNullEmp({ data: building, subMethod: 'btn - save', })?.result || condominiumBoardElectionClosed}
                                                        //onClick={(e) => condominiumBoardElectionEditAsync(e)}
                                                        tooltip='tooltip'
                                                        title={labels?.save?.[languageObj?.id]}
                                                        type='submit'>
                                                        <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    {/* <button className='btn btn-outline-danger float-right'
                                                        disabled={isEmpty(building) || condominiumBoardElectionClosed}
                                                        hidden
                                                        //id={btnCondominiumBoardElectionDeleteId}
                                                        //onClick={(e) => localCondominiumBoardElectionDeleteGetAsync(e)}
                                                        tooltip='tooltip'
                                                        title={labels?.delete?.[languageObj?.id]}
                                                        type='button'>
                                                        <i className={icons?.trash}></i>
                                                    </button> */}
                                                </div>
                                            </div>
                                        </form>

                                        {/* <div className='row'>
                                            <div className='col-md-3 text-muted'>
                                                <h6>{labels?.applicants?.[languageObj?.id]}</h6>
                                            </div>
                                            <div className='col-md-9'>
                                                <hr />
                                            </div>
                                        </div> */}

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                {/* <button className='btn btn-outline-success float-right btn-sm'
                                                    disabled={isEmpty(building) || condominiumBoardElectionClosed || btnAddDisabled}
                                                    onClick={(e) => electionApplicantAddEditDetailsDeleteAsync(e, '', '', 0, 0)}
                                                    tooltip='tooltip' title={labels?.add?.[languageObj?.id]}>
                                                    <i className={icons?.plusCircle}></i></button>
                                                <button className='btn btn-outline-danger float-right btn-sm mx-1'
                                                    disabled={isEmpty(building) || condominiumBoardElectionClosed}
                                                    hidden
                                                    id={btnCondominiumBoardElectionDetailDeleteId}
                                                    onClick={(e) => condominiumBoardElectionDetailDeleteGetAsync(e)}
                                                    tooltip='tooltip'
                                                    title={labels?.delete?.[languageObj?.id]}>
                                                    <i className={icons?.trash}></i></button>
                                                <div> */}
                                                {/* <LoadingSection alt='loadingSection'
                                                        className={reactHtml?.overlay?.darkTextWhite}
                                                        showText={true}
                                                        text={messages?.processing?.[languageObj?.id]}
                                                        height={25}
                                                        hidden={!showLoading?.applicants}
                                                        width={25}
                                                        languageId={languageObj?.id}
                                                        subMethod={currentMethod} /> */}
                                                {/* <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}> */}
                                                {/* <table id={dtElectionApplicantsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table> */}
                                                {/* <table id={dtElectionApplicantsId} className='table table-sm table-bordered display'></table> */}
                                                {/* <table id={dtElectionApplicantsId} className={globalSettings?.html?.dataTables?.formats?.smBorderedDisplay}></table> */}
                                                {/* </div> */}
                                            </div>

                                        </div>
                                    </div>
                                    {/* </div> */}
                                    {/* : */}
                                    {/* <div></div> */}
                                    {/* } */}
                                    {/* </div> */}
                                    {/* : */}
                                    {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                width={40}
                                                height={40}
                                                color={colors?.infoColorExp}
                                                msgText={messages?.processing?.[languageObj?.id]}
                                                msgOrientation='text-center'
                                                msgTextMuted={true} /> */}
                                    {/* } */}
                                </div>

                                {/*applicants*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactHtml?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.applicants}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.applicants?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.applicants}></img> - {labels?.applicants?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <button id={controls?.dataTables?.applicants?.buttons?.create?.id}
                                                    className={controls?.dataTables?.applicants?.buttons?.create?.className}
                                                    //className='btn btn-outline-success float-right btn-sm'
                                                    disabled={isUndNullEmp({ data: building, subMethod: currentMethod, })?.result || condominiumBoardElectionClosed || btnAddDisabled}
                                                    onClick={(e) => electionApplicantAddEditDetailsDeleteAsync({ e: e, id: '', description: '', rowIndex: 0, processType: 0, subMethod: 'brn - applicantAdd', })}
                                                    tooltip='tooltip' title={labels?.add?.[languageObj?.id]}>
                                                    {/* <i className={icons?.plusCircle}></i> */}
                                                    <i id={controls?.dataTables?.applicants?.icons?.create?.id} className={controls?.dataTables?.applicants?.icons?.create?.className} /> <span id={controls?.dataTables?.applicants?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                <button id={controls?.dataTables?.applicants?.buttons?.delete?.id}
                                                    className={controls?.dataTables?.applicants?.buttons?.delete?.className}
                                                    //className='btn btn-outline-danger float-right btn-sm mx-1'
                                                    disabled={isUndNullEmp({ data: building, subMethod: 'btn - aaplicantsDelete', })?.result || condominiumBoardElectionClosed}
                                                    hidden
                                                    onClick={(e) => electionApplicantDeletePostAsync({ e: e, subMethod: 'btn - applicantsDelete', })}
                                                    tooltip='tooltip'
                                                    title={labels?.delete?.[languageObj?.id]}>
                                                    <i className={icons?.trash}></i>
                                                </button>
                                                <div>
                                                    <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                        {/* <table id={dtElectionApplicantsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table> */}
                                                        {/* <table id={dtElectionApplicantsId} className='table table-sm table-bordered display'></table> */}
                                                        <table id={dtElectionApplicantsId} className={globalSettings?.html?.dataTables?.formats?.smBorderedDisplay}></table>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* </div> */}
                                            {/* : */}
                                            {/* <div></div> */}
                                            {/* } */}
                                            {/* </div> */}
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                width={40}
                                                height={40}
                                                color={colors?.infoColorExp}
                                                msgText={messages?.processing?.[languageObj?.id]}
                                                msgOrientation='text-center'
                                                msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>

                                    </div>

                                </div>{/*col*/}
                            </div>
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>{/* /.content */}
            </div>

            {electionApplicantShowModal ?
                <ElectionApplicantsAddEditDetails $={$}
                    auth={auth}
                    electionApplicant={electionApplicant}
                    setElectionApplicant={setElectionApplicant}
                    dtId={dtElectionApplicantsId}
                    setElectionApplicants={setElectionApplicants}
                    electionApplicants={electionApplicants}
                    showModal={electionApplicantShowModal}
                    setShowModal={setElectionApplicantShowModal}
                    userDataGetAsync={userDataGetAsync}
                    processValues={processValues}
                    languageObj={languageObj} />
                :
                <></>}
        </div>
    )
}